import React, { useEffect } from "react";
import TodoIcon from "../../../../../assets/icons/todo-icon.svg";
import { Badge, Button } from "antd";
import { HandlerImpl } from "../handler/HandlerImpl";

export const MainUI = ({ handler }: { handler: HandlerImpl }) => {

  useEffect(() => {
    handler.getTodoTaskNumber()
  }, [])
  
  return (
    <div className="center-item">
      <Badge count={handler.countTodoTask} className="avatar-badge-button">
        <Button
          type="link"
          style={{ border: "none" }}
          icon={<img alt="" style={{ width: "24px" }} src={TodoIcon} />}
          onClick={(e) => {
            e.stopPropagation();
            handler.goToTD001()
          }}
        ></Button>
      </Badge>
    </div>
  );
};
